export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20comic%20book%20reading%20atmosphere%20with%20floating%20manga%20speech%20bubbles%20and%20dynamic%20speed%20lines%2C%20warm%20orange%20to%20red%20gradient%20background%20with%20soft%20glow%20effects%2C%20stylized%20illustration%20of%20an%20open%20book%20radiating%20energy%2C%20Japanese%20manga%20aesthetic%20meets%20modern%20digital%20reading%2C%20cinematic%20warm%20lighting%20with%20dramatic%20contrast%2C%202D%20flat%20illustration%20style%2C%20clean%20composition%20with%20negative%20space%20for%20text%20overlay%2C%20artistic%20and%20abstract%20rather%20than%20photorealistic&width=1600&height=900&seq=hero-manga-bg&orientation=landscape"
          alt="虫虫动漫 - 漫画全集免费在线阅读主视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-accent-400 bg-accent-950/60 rounded-full mb-5 tracking-wider uppercase">
              全集完结漫画 · 下拉式阅读
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              虫虫动漫 - 漫画全集免费在线阅读
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              免翻页，不等待，完整故事轻松读
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              虫虫动漫专注提供漫画全集资源，采用独创的下拉式阅读模式，让您无需反复翻页即可一次性看完全卷完结漫画。
              平台每日更新海量热门漫画，涵盖热血、恋爱、玄幻、悬疑等多种类型，无论您是追更新还是补完结，
              这里都是您最佳的漫画大全阅读选择。完整版故事，极速加载，随时随地畅享沉浸式漫画阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-white/80">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm font-medium">每日更新 追更不等待</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm font-medium">海量全卷 一口气看完</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm font-medium">安全免费 纯净无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3 border border-white/30 text-white font-medium rounded-lg hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[360px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20illustration%20of%20a%20digital%20tablet%20displaying%20colorful%20manga%20panels%20with%20action%20scenes%2C%20floating%20comic%20effects%20like%20speed%20lines%20and%20sound%20effect%20text%2C%20warm%20orange%20and%20red%20ambient%20lighting%2C%20Japanese%20anime%20art%20style%2C%20dynamic%20composition%20with%20dramatic%20perspective%2C%20rich%20colors%20and%20bold%20contrasts%2C%20clean%20background%20with%20soft%20glow%2C%20modern%20digital%20aesthetic&width=800&height=1000&seq=hero-manga-visual&orientation=portrait"
                alt="虫虫动漫下拉式漫画阅读体验展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}